import React from 'react';

export const ObjectCount = (props) => {
    return (
        <div className={`countsOfTypeTwo ${props.className}`}>
        <div className='countypeTwoObjects'>{props.data.length < 10 ? 0 : ''}{(props.data.length === 0 ? 1 : props.data.length)}</div>
        </div>
    )
}